import React, { useMemo } from 'react'
import { usePathname, useRouter } from 'next/navigation'

import { cn, useFilter, useLocale } from '@rewardops/ui'
import { CategorySummaryData } from '@rewardops/utils'

export function CategoriesFilter({
  categories,
  onSelectionSet,
}: {
  categories: CategorySummaryData[] | undefined
  onSelectionSet?: Function
}) {
  const memoizedCategories = useMemo(() => categories, [categories])

  if (!categories) {
    return undefined
  }

  return (
    <div className="mb-5 flex flex-col items-start gap-3">
      {memoizedCategories?.map((category) => (
        <CategoryItem
          key={category.code}
          category={category}
          onSelectionSet={onSelectionSet}
        />
      ))}
    </div>
  )
}

const CategoryItem = ({
  category,
  onSelectionSet,
}: {
  category: CategorySummaryData
  onSelectionSet?: Function
}) => {
  const { name, code } = category
  const { subCategory } = useFilter()
  const { locale } = useLocale()
  const router = useRouter()
  const pathname = usePathname()
  const isSelected = subCategory === code

  const handleClick = () => {
    if (onSelectionSet) onSelectionSet()

    if (subCategory === code) {
      return
    }

    router.push(`${pathname}?subCategory=${code}`)
  }

  return (
    <button
      id={`category-select-${code}`}
      role="button"
      tabIndex={0}
      className={cn(
        'border-b border-transparent hover:border-b hover:border-tenant-primary-color hover:font-semibold hover:text-tenant-primary-color',
        {
          'font-semibold': isSelected,
          'border-none': isSelected,
          'hover:border-none': isSelected,
          'hover:text-black': isSelected,
        },
      )}
      onClick={handleClick}
    >
      {name[locale]}
    </button>
  )
}

export default CategoriesFilter
